module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.76/js/sprocket_orange.svg"